import { useState, useEffect, useContext } from "react";
import { Outlet } from "react-router-dom";
import { styled } from "@mui/material/styles";
import DashboardNavbar from "./DashboardNavbar";
import DashboardSidebar from "./DashboardSidebar";
import {
  setAdmins, setCreatorRequest, setCreators, setGifts,
  setUsers, setVideos, setAdminData,
} from "../../store";
import { useDispatch } from "react-redux";
import { db } from "../../database/db";
import {
  collection, onSnapshot, getDocs, query, where, doc,
} from "firebase/firestore";
import { AuthContext } from "../../Context/authContext";

const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 92;

const RootStyle = styled("div")({ display: "flex", minHeight: "100%", overflow: "hidden" });

const MainStyle = styled("div")(({ theme }) => ({
  flexGrow: 1,
  overflow: "auto",
  minHeight: "100%",
  paddingTop: APP_BAR_MOBILE + 24,
  paddingBottom: theme.spacing(10),
  [theme.breakpoints.up("lg")]: {
    paddingTop: APP_BAR_DESKTOP + 24,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
}));

export default function DashboardLayout() {
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const [auth] = useContext(AuthContext);

  useEffect(() => {
    if (!auth) return;

    // Live user list
    const unUsers = onSnapshot(collection(db, "User"), (snap) => {
      dispatch(setUsers(snap.docs.map((d) => ({ id: d.id, ...d.data() }))));
    });

    // Live admin list
    const unAdmins = onSnapshot(collection(db, "AdminUser"), (snap) => {
      dispatch(setAdmins(snap.docs.map((d) => ({ id: d.id, ...d.data() }))));
    });

    // Logged-in admin data
    const unAdminData = onSnapshot(
      query(collection(db, "AdminUser"), where("email", "==", auth.email)),
      (snap) => {
        if (!snap.empty) {
          dispatch(setAdminData({ id: snap.docs[0].id, ...snap.docs[0].data() }));
        }
      }
    );

    // Gifts
    const unGifts = onSnapshot(collection(db, "Gifts"), (snap) => {
      dispatch(setGifts(snap.docs.map((d) => ({ id: d.id, ...d.data() }))));
    });

    // Creator requests (pending)
    getDocs(query(collection(db, "User"), where("isCreator", "==", "pending")))
      .then((snap) => {
        const list = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
        dispatch(setCreatorRequest(list));
      })
      .catch(() => {});

    // Approved creators
    getDocs(query(collection(db, "User"), where("isCreator", "==", "approved")))
      .then((snap) => {
        const list = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
        dispatch(setCreators(list));
      })
      .catch(() => {});

    return () => {
      unUsers();
      unAdmins();
      unAdminData();
      unGifts();
    };
  }, [auth]);

  return (
    <RootStyle>
      <DashboardNavbar onOpenSidebar={() => setOpen(true)} />
      <DashboardSidebar isOpenSidebar={open} onCloseSidebar={() => setOpen(false)} />
      <MainStyle>
        <Outlet />
      </MainStyle>
    </RootStyle>
  );
}
